var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bankAbbrev)?_c('img',{staticClass:"bank",style:(("background-color: " + _vm.bankColor)),attrs:{"src":require(("@/assets/images/banks/" + _vm.bankAbbrev + ".svg")),"alt":_vm.bankAbbrev,"width":"25"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }